import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "text-left",
  "data-testid": "upload-self-check-step"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold text-textPrimary mb-1" }, "Antes de enviar, confira a folha", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-neutral50 mb-3",
  "data-testid": "upload-self-check-loading"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-neutral50 mb-3",
  "data-testid": "upload-self-check-expected"
}
const _hoisted_5 = {
  key: 2,
  class: "text-sm text-neutral50 mb-3",
  "data-testid": "upload-self-check-expected-missing"
}
const _hoisted_6 = {
  key: 3,
  class: "text-sm text-[#68688D] -mt-2 mb-3",
  "data-testid": "upload-self-check-unidentified"
}
const _hoisted_7 = { class: "flex flex-col gap-1 border border-gray-200 rounded-lg px-4 py-3" }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = ["checked", "data-testid", "onChange"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50 mt-3" }, " \"Enviar assim mesmo\" grava a sua declaração no histórico do registro; o auditor vê o que foi apontado antes de abrir a folha. ", -1)

import { computed, ref, watch } from 'vue'
import Network from '@/Network'
import type { DSAttendanceExpectedSummaryItem } from '@/Network/Types/Responses/DsAttendancePolicyResponses'
import {
  buildExpectedSummaryText,
  buildSelfCheckItems,
  buildUnidentifiedCoverageNotice,
  totalExpectedDoctorStations,
  type SelfCheckKey,
  type SelfCheckState
} from './self-check'

/**
 * Eixo 2A — passo do checklist no envio da folha. Não valida nada: nenhum item marcado ainda
 * permite "Enviar assim mesmo". O que o passo entrega é a declaração do emissor e o número de
 * plantões que a escala prevê, que é a informação que ele não tinha ao olhar a folha.
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'StepChecklist',
  props: {
    modelValue: {},
    formattedDate: {},
    healthUnitId: {},
    scheduleIds: {},
    referenceDate: {},
    pages: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const state = computed(() => props.modelValue)

const summary = ref<DSAttendanceExpectedSummaryItem[] | null>(null)
const isLoading = ref(false)

const expectedSummaryText = computed(() =>
  buildExpectedSummaryText({ summary: summary.value, pages: props.pages })
)

const unidentifiedNotice = computed(() => buildUnidentifiedCoverageNotice(summary.value))

const items = computed(() =>
  buildSelfCheckItems({
    formattedDate: props.formattedDate,
    expectedDoctorStations: totalExpectedDoctorStations(summary.value)
  })
)

function toggle(key: SelfCheckKey) {
  emit('update:modelValue', { ...props.modelValue, [key]: !props.modelValue[key] })
}

async function loadExpectedSummary() {
  if (!props.healthUnitId || !props.referenceDate || props.scheduleIds.length === 0) return

  isLoading.value = true
  try {
    summary.value = await Network.dsAttendance.getExpectedSummary({
      healthUnitId: props.healthUnitId,
      referenceDate: props.referenceDate,
      scheduleIds: props.scheduleIds
    })
  } catch (error) {
    // Silencioso de propósito: o checklist é auxiliar do envio, e um toast de erro aqui
    // sugeriria ao emissor que o envio falhou.
    console.debug('[AttendanceUpload] escala prevista indisponível:', error)
    summary.value = null
  } finally {
    isLoading.value = false
  }
}

watch(
  () => [props.healthUnitId, props.referenceDate, props.scheduleIds.join(',')],
  () => loadExpectedSummary(),
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Consultando a escala prevista... "))
      : (expectedSummaryText.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(expectedSummaryText.value), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, " Páginas enviadas: " + _toDisplayString(_ctx.pages) + ". ", 1)),
    (!isLoading.value && unidentifiedNotice.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(unidentifiedNotice.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
        return (_openBlock(), _createElementBlock("label", {
          key: item.key,
          class: "flex items-start gap-2 text-sm text-textPrimary cursor-pointer",
          "data-testid": `upload-self-check-item-${item.key}`
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            class: "mt-0.5",
            checked: state.value[item.key],
            "data-testid": `upload-self-check-checkbox-${item.key}`,
            onChange: ($event: any) => (toggle(item.key))
          }, null, 40, _hoisted_9),
          _createElementVNode("span", null, _toDisplayString(item.label), 1)
        ], 8, _hoisted_8))
      }), 128))
    ]),
    _hoisted_10
  ]))
}
}

})